import { render, staticRenderFns } from "./HomePageLayout.vue?vue&type=template&id=f839f16c&scoped=true&"
import script from "./HomePageLayout.vue?vue&type=script&lang=js&"
export * from "./HomePageLayout.vue?vue&type=script&lang=js&"
import style0 from "./HomePageLayout.vue?vue&type=style&index=0&id=f839f16c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f839f16c",
  null
  
)

export default component.exports